import { render } from "./TeachingCourseware.vue?vue&type=template&id=84f5b7e6&scoped=true"
import script from "./TeachingCourseware.vue?vue&type=script&lang=js"
export * from "./TeachingCourseware.vue?vue&type=script&lang=js"

import "./TeachingCourseware.vue?vue&type=style&index=0&id=84f5b7e6&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f5b7e6"]])

export default __exports__